export default "__VITE_ASSET__r6L1B_Lg__"